var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import qs from 'query-string';
import whichEnv from '@ally/which-env';
import { initialize, } from 'launchdarkly-js-client-sdk';
import { isString, uniqueID, getJSONLocalStorage, getJSONSessionStorage, setJSONSessionStorage, } from '@ally/utilitarian';
import log from './whisper';
export var USER_KEY = 'ld-user-key';
export var BROWSER_KEY = 'ld-browser-key';
export var SESSION_ATTRS_KEY = 'ld-session-attrs';
export var PERSISTED_ATTRS_KEY = 'ld-persisted-attrs';
/**
 * A mapping of environment names to launch darkly user keys.
 * These are used below in `getLaunchDarklyConfig` to select the default key
 * if no `key` is provided in the options
 */
var defaultLaunchDarklyKeys = {
    dev: '5e179c1298f5e308e42d7a89',
    cap: '5e7272e85129c9071bdf08c1',
    qa1: '5e7272e85129c9071bdf08c1',
    qa2: '5e7272e85129c9071bdf08c1',
    qa3: '5e7272e85129c9071bdf08c1',
    psp: '5e67ae7be7b2890a81545510',
    prod: '5e67ae7be7b2890a81545510',
    local: '5cae06c225ef5608100db5dc',
};
/**
 * Returns information about the current application that will be "mixed in"
 * with the user's LD custom attributes.
 */
function getApplication(env, options) {
    var host = options.host || window.location.hostname;
    var _a = options.channel, channel = _a === void 0 ? 'web' : _a, platform = options.platform;
    var _b = env.prod, prodC = _b.C, prodD = _b.D;
    return {
        host: host,
        prodC: prodC,
        prodD: prodD,
        channel: channel,
        platform: platform,
    };
}
/**
 * Gets "persisted" user attributes (from local storage).
 */
export function getPersistedAttributes() {
    var _a;
    return (_a = getJSONLocalStorage(PERSISTED_ATTRS_KEY)) !== null && _a !== void 0 ? _a : {};
}
/**
 * Gets "session" user attributes (from session storage and the querystring).
 * Updates with the latest query string attributes each time this is called.
 */
export function getSessionAttributes() {
    var _a;
    var attrs = (_a = getJSONSessionStorage(SESSION_ATTRS_KEY)) !== null && _a !== void 0 ? _a : {};
    var query = qs.parse(window.location.search, { arrayFormat: 'bracket' });
    var attributes = __assign(__assign({}, attrs), query);
    setJSONSessionStorage(SESSION_ATTRS_KEY, attributes);
    return attributes;
}
/**
 * Gets the "browser key" for the current user.
 * This is a unique identifier that's stored in local storage that's used to
 * identify a specific browser across sessions.
 */
export function getSetBrowserKey() {
    var key = localStorage.getItem(BROWSER_KEY);
    var uid = key || uniqueID();
    if (key !== uid)
        localStorage.setItem(BROWSER_KEY, uid);
    return uid;
}
export function getBaseUser(key, username, attributes) {
    var anonymous = key === 'anonymous';
    return __assign(__assign({}, attributes), { kind: 'user', key: key, name: isString(username) ? username : undefined, anonymous: anonymous });
}
/**
 * Gets the initial launch darkly user with all attributes from both session and
 * local storage set in `user.custom`. Includes application information in
 * `user.custom`.
 */
export function getInitUser(env, options) {
    var key = window.sessionStorage.getItem(USER_KEY) || 'anonymous';
    var base = { browserKey: getSetBrowserKey() };
    var session = getSessionAttributes();
    var persisted = getPersistedAttributes();
    var application = getApplication(env, options);
    // Allows application information to be overridden in lower level environments.
    var attributes = env.isProd
        ? __assign(__assign(__assign(__assign({}, base), persisted), session), application) : __assign(__assign(__assign(__assign({}, base), persisted), application), session);
    return getBaseUser(key, null, attributes);
}
/**
 * Given an LD client and initial user, will return a function that will update
 * the user in launch darkly with the given user key and attributes. Attributes
 * will be combined with the initial (likely anonymous) user.
 */
export function getUserRegister(client, initialUser) {
    var _this = this;
    return function (key, username, attributes, callback) { return __awaiter(_this, void 0, void 0, function () {
        var user, flags;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    user = getBaseUser(key, username, __assign(__assign({}, initialUser), attributes));
                    log.info({
                        message: ['Registering User:', user],
                    });
                    sessionStorage.setItem(USER_KEY, key);
                    return [4 /*yield*/, client.identify(user, undefined, callback)];
                case 1:
                    flags = _a.sent();
                    return [2 /*return*/, {
                            user: user,
                            flags: flags,
                        }];
            }
        });
    }); };
}
/**
 * Given some options, will return a fully-qualified LaunchDarkly config.
 * Users can override configuration settings via `options.ldConfig`.
 */
export function getClient(_a) {
    var _b = _a.ldConfig, ldConfig = _b === void 0 ? {} : _b, options = __rest(_a, ["ldConfig"]);
    var env = whichEnv(window.location.href);
    var key = options.key || env.pick(defaultLaunchDarklyKeys);
    var initialUser = getInitUser(env, options);
    var client = initialize(key, initialUser, __assign({ streaming: false, sendEventsOnlyForVariation: true }, ldConfig));
    return {
        key: key,
        client: client,
        initialUser: initialUser,
    };
}
//# sourceMappingURL=utils.js.map